<template>
  <v-layout row wrap>
    <YesNoModal ref="YesNoModal" />
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <Loader ref="Loader"></Loader>
    <ProceedModal ref="ProceedModal" />
    <v-toolbar dense dark>
      <v-toolbar-title>{{Venue.Name}} - Inspections</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="success" dark icon @click="returnToCustomers" large>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-menu absolute>
        <template v-slot:activator="{ on }">
          <v-btn color="success" dark v-on="on" small>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="syncData">
            <v-list-tile-title>Check Out</v-list-tile-title>
          </v-list-tile>
          <!-- <v-list-tile @click="syncData">
            <v-list-tile-title>Sync Data </v-list-tile-title>
          </v-list-tile>-->
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-layout justify-center v-if="Allocations.length == 0" mt-2 ml-5>
      <span>**You have not allocated any inspections</span>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12>
        <v-list>
          <v-list-group v-for="item in Allocations" :key="item.AllocatedInspection.UID"
            :disabled="item.Inspections.InspectionItems.length == 0">
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon :color="item.Inspections.InspectionItems.length == 0 ? 'success' : '' ">mdi-eye
                  </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.Inspections.CustomerInspection.Name }} -
                    {{item.AllocatedInspection.Reference}}
                    <span v-if="item.Inspections.InspectionItems.length == 0" style="color:green">
                      - Inspections
                      Complete
                    </span>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile v-for="subItem in item.Inspections.InspectionItems"
              :key="item.AllocatedInspection.UID + subItem.ID" class="ml-3" @click="completeInspection(item, subItem)">
              <v-list-tile-avatar>
                <v-icon>mdi-menu-right-outline</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.Name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-flex>
    </v-layout>

    <v-dialog v-model="CompleteInspectionDialog" width="500" persistent>
      <v-card>
        <v-toolbar dense dark>
          <v-toolbar-title>{{SelectedInspectionItem.Name}}</v-toolbar-title>
        </v-toolbar>

        <v-form ref="InspectionCompleteForm">
          <v-layout row justify-center>
            <v-flex xs10>
              <v-checkbox v-model="SelectedInspectionItem.Completed" label="Is Inspection Complete?"></v-checkbox>
              <v-text-field label="Comments" v-model="SelectedInspectionItem.Comments"></v-text-field>

              <v-layout ma-2>
                <input type="file" name="file" id="file" class="inputfile" accept="image/*" capture
                  @change="addImageFile" ref="myFile" />
                <!-- <v-btn color="secondary" @click="startStream()">Upload image(s)</v-btn> -->
              </v-layout>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click="StoreInIndexedDB"
              :disabled="!SelectedInspectionItem.Completed && SelectedInspectionItem.Comments == null || SelectedInspectionItem.Comments == ' '">
              I accept</v-btn>
            <v-btn color="error" flat @click="CancelJobComplete">Cancel</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import JWT from "jsonwebtoken";
  import moment from "moment";
  import supervisorMW from "@/libs/middleware/supervisorMW";

  export default {
    data() {
      return {
        ImgCaptureSrc: "",
        CompleteInspectionDialog: false,
        showPhotoDialog: false,
        pictureDialog: false,
        InspectionToCompleteData: {
          Comments: "",
          Completed: false
        },
        SelectedInspectionData: {},
        SelectedInspectionItem: {},
        Allocations: [],
        Venue: {},
        CheckInLong: null,
        CheckInLat: null,
        CheckOutLong: null,
        CheckOutLat: null,
        isWifi: false,
        SystemUserID: null,
        IndexDBTxs: [],
        fieldRules: [v => !!v || "Field is required"],
        file: null,
        IDBVenueList: [],
        IDBInspectionList: [],
        CustomerList: [],
        CustomerInspectionList: [],
        tmpAllocations: [],
      };
    },
    mounted() {
      let self = this;

      try {
        self.fetchVenueData();
        self.fetchAllocations();
      } catch (err) {
        self.$refs.ErrorModal.setText("Error: " + err.toString());
        self.$refs.ErrorModal.show();
      }
    },
    computed: {
      AllInspectionsComplete() {
        var bool = true;
        this.Allocations.forEach(element => {
          if (element.Inspections.InspectionItems.length > 0) {
            bool = false;
          }
        });

        return bool;
      }
    },
    methods: {
      addImageFile() {
        let self = this;
        self.file = self.$refs.myFile.files[0];
        console.log("[IMAGE DATA]", self.file)
      },
      fetchAllocations() {
        let self = this;
        let venueID = self.$route.params.venueID;
        //let sessionData = self.$store.getters.getUserSessionData;
        //let tokenDecoded = JWT.decode(sessionData.AccessToken);

        let mw = new supervisorMW(self);

        mw.GetTXes()
          .then(r => {
            self.IndexDBTxs = r;
            console.log("[IDB TXES]", self.IndexDBTxs);

            //self.SystemUserID = tokenDecoded.USER_ID;
            let systemUserID = self.SystemUserID;
            let date = moment().format(`YYYY-MM-DD`);
            var tmpInspection = [];

            mw.GetAllocatedInspections().then(r => {
              console.log('[SUPERVISOR ALLOCATIONS]', r);
              var AllAllocatedInspections = r;

              var UsersAllocatedInspections = AllAllocatedInspections.filter(inspection => {
                return (inspection.AllocatedInspection.SystemUserID == systemUserID && inspection
                  .AllocatedInspection.CustomerVenueID == venueID);
              })
              console.log("[UsersAllocatedInspections]", UsersAllocatedInspections)

              self.$refs.Loader.show();
              self.IDBInspectionList.forEach(inspection => {
                UsersAllocatedInspections.forEach(allocation => {
                  if (inspection.CustomerInspection.ID == allocation.AllocatedInspection
                    .CustomerInspectionID) {
                    allocation.Inspections = JSON.parse(JSON.stringify(inspection));
                    tmpInspection.push(JSON.parse(JSON.stringify(inspection)));
                    allocation.Inspections.InspectionItems.forEach(item => {
                      item.UID = allocation.AllocatedInspection.UID;
                      setTimeout(() => {
                        self.checkIfTxExistsIndexDB(item, allocation);
                      }, 20)
                    })
                  }
                })
              })
              // self.checkIfTxExistsIndexDB(tmpInspection);
              self.Allocations = UsersAllocatedInspections;
              console.log("[ALLOCATIONS]", self.Allocations)
              self.$refs.Loader.hide()
            })
            .catch(error => {
             // console.error("inspections", error.toString())
            })
          })
          .catch(err => {
            self.$refs.Loader.hide();
          });
      },
      checkIfTxExistsIndexDB(item, allocation) {
        let self = this;

        self.IndexDBTxs.forEach(tx => {
          console.log(allocation.Inspections.InspectionItems)
          allocation.Inspections.InspectionItems.forEach(alloc => {
            if (tx.CustomerInspectionItemID == item.ID && item.UID == tx.SupervisorAllocatedInspectionID &&
              alloc.ID == item.ID && alloc.UID == tx.SupervisorAllocatedInspectionID) {
              var index = allocation.Inspections.InspectionItems.indexOf(item);
              allocation.Inspections.InspectionItems.splice(index, 1);
            }
          })
        })
      },
      fetchVenueData() { // inspections, etc for this customer & venue
        let self = this;
        let mw = new supervisorMW(self);
        let venueID = self.$route.params.venueID;

        mw.GetUserData().then(r => {
          self.SystemUserID = r[0].UserID;
          r[0].CustomerList.forEach(customer => {
            self.CustomerList.push(customer.Customer); // CUSTOMER LIST

            customer.Venues.forEach(venue => {
              self.IDBVenueList.push(venue.CustomerVenue);

              var filteredVenues = self.IDBVenueList.filter(ven => {
                return ven.ID == venueID;
              })
              self.Venue = filteredVenues[0];

              venue.Inspections.forEach(inspection => {
                if (inspection.CustomerInspection.CustomerVenueID == venueID) {
                  self.IDBInspectionList.push(inspection);
                }
              })
            })
          })
        })
        .catch(error => {
//
        })
      },
      completeInspection(data, item) {
        let self = this;

        self.SelectedInspectionData = data;
        self.SelectedInspectionItem = item;
        self.CompleteInspectionDialog = true;
      },
      closeDialog() {
        let self = this;

        self.showPhotoDialog = false;

        //override wifi can post
        self.canUpload = true;
      },
      checkConnection(e) {
        let self = this;
        try {
          var connection =
            navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection;
          var type = connection.type;
          if (connection) {
            //CONNECTED VIA PC
            if (connection.type === undefined) {
              this.isWifi = true;
              console.log("[CONNECTED VIA PC]");
              this.canUpload = true;
            }

            //MOBILE
            if (connection.type === "cellular") {
              this.isWifi = false;
              this.canUpload = true;
              console.log("[CONNECTED VIA MOBILE] - CELLULAR");
            } else if (connection.type === "wifi") {
              this.isWifi = true;
              this.canUpload = true;
              console.log("[CONNECTED VIA MOBILE] - WIFI");
            }
            console.log("[CONNECTION TYPE]", connection);
          }
        } catch (error) {
          self.isWifi = true;
          self.canUpload = true;
          console.warn(
            "[CONNECTION TYPE] IOS, could not determine connection type for safari. Will use any form of data to upload",
            error, error.toString());
        }
      },
      startStream() {
        let self = this;
        self.imgByteArr = null;
        self.showPhotoDialog = true;
        const constraints = {
          video: {
            facingMode: self.shouldFaceUser ? "user" : "environment"
          }
        };

        navigator.mediaDevices.getUserMedia(constraints).then(stream => {
          this.mediaStream = stream;
          this.$refs.video.srcObject = stream;
          this.$refs.video.play();
        });
      },
      StoreInIndexedDB() {
        // INDEXED DB STORE
        let self = this;
        let mw = new supervisorMW(self);
        self.SelectedInspectionItem.UID = self.SelectedInspectionData.AllocatedInspection.UID;

        let inspectionData = self.SelectedInspectionData;
        let inspectionItem = self.SelectedInspectionItem;
        let txData = self.InspectionToCompleteData;
        let dateNow = moment().format("YYYY-MM-DDThh:mm:ss");

        var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (is_safari) {
          let bytes = null;
          var reader = new FileReader();
          reader.onload = function () {
            bytes = Array.from(new Uint8Array(reader.result));

            mw.PostSingleJobTxToIndexedDB(
              inspectionData.AllocatedInspection.UID,
              self.SystemUserID,
              inspectionItem.ID,
              false, // use file info is false, we send the byte[]
              bytes,
              inspectionItem.Comments,
              inspectionItem.Completed,
              dateNow
            ).then(r => {
              console.log("[STORED IN INDEXED DB]", r);
              console.log("[STORED 1]")
              if (r != null) {
                if (self.SelectedInspectionItem.UID == self.SelectedInspectionData.AllocatedInspection.UID) {
                  var filteredInspection = self.SelectedInspectionData.Inspections.InspectionItems.filter(
                    item => {
                      return item.UID
                    })
                  let index = self.SelectedInspectionData.Inspections.InspectionItems.indexOf(
                    self.SelectedInspectionItem
                  );
                  self.SelectedInspectionData.Inspections.InspectionItems.splice(index, 1);
                }

                self.$refs.InspectionCompleteForm.reset();
                self.CompleteInspectionDialog = false;
              }

              self.file = null;
              document.getElementById("file").value = "";
            });

          };
          if (self.file != null && self.file != undefined) {
            reader.readAsArrayBuffer(self.file);
          } else {
            mw.PostSingleJobTxToIndexedDB(
              inspectionData.AllocatedInspection.UID,
              self.SystemUserID,
              inspectionItem.ID,
              false, // use file info is false, we send the byte[]
              bytes,
              inspectionItem.Comments,
              inspectionItem.Completed,
              dateNow
            ).then(r => {
              console.log("[STORED IN INDEXED DB]", r);
              console.log("[STORED 2]")
              if (r != null) {
                if (self.SelectedInspectionItem.UID == self.SelectedInspectionData.AllocatedInspection.UID) {
                  let index = self.SelectedInspectionData.Inspections.InspectionItems.indexOf(
                    self.SelectedInspectionItem
                  );
                  self.SelectedInspectionData.Inspections.InspectionItems.splice(index, 1);
                }

                self.$refs.InspectionCompleteForm.reset();
                self.CompleteInspectionDialog = false;
              }

              self.file = null;
              document.getElementById("file").value = "";
            });
          }
        } else {
          mw.PostSingleJobTxToIndexedDB(
            inspectionData.AllocatedInspection.UID,
            self.SystemUserID,
            inspectionItem.ID,
            true, // we pass true here as we are sending the file info to index db
            self.file,
            inspectionItem.Comments,
            inspectionItem.Completed,
            dateNow
          ).then(r => {
            console.log("[STORED IN INDEXED DB]", r);
            console.log("[STORED 3]");
            var AllocationToDeleteFrom = null;

            if (r != null) {
              for (var i = 0; i < self.Allocations.length; i++) {
                if (self.Allocations[i].UID == self.SelectedInspectionData.UID) {
                  AllocationToDeleteFrom = self.Allocations[i];
                }
              }

              var index = AllocationToDeleteFrom.Inspections.InspectionItems.indexOf(self.SelectedInspectionItem);
              AllocationToDeleteFrom.Inspections.InspectionItems.splice(index, 1);

              self.$refs.InspectionCompleteForm.reset();
              self.CompleteInspectionDialog = false;
            }

            self.file = null;
            document.getElementById("file").value = "";
          });
        }
      },
      StoreIncompletedItemsInIndexedDB() {
        // INDEXED DB STORE
        let self = this;
        let mw = new supervisorMW(self);

        let dateNow = moment(Date.now()).format("YYYY-MM-DDThh:mm:ss");
        var success = false;

        for (let index = 0; index < self.Allocations.length; index++) {
          const element = self.Allocations[index];

          if (element.Inspections.InspectionItems.length > 0) {
            element.Inspections.InspectionItems.forEach((item, idx) => {
              mw.PostSingleJobTxToIndexedDB(
                element.AllocatedInspection.UID,
                self.SystemUserID,
                item.ID,
                false, // false by default for all items that are not completed when checking out (UseFileInfo = false)
                null,
                "",
                false,
                dateNow
              ).then(r => {
                console.log("[STORED IN INDEXED DB]", r);

                if (r != null) {
                  self.SelectedInspectionData = element;
                  let index = self.SelectedInspectionData.Inspections.InspectionItems.indexOf(
                    self.SelectedInspectionItem
                  );
                  self.SelectedInspectionData.Inspections.InspectionItems.splice(
                    index,
                    1
                  );
                  self.$refs.Loader.hide();
                  var success = true;
                  self.$refs.InspectionCompleteForm.reset();
                  self.CompleteInspectionDialog = false;
                }
              });
            });
          }
        }
        setTimeout(() => {
          self.postData();
        }, 200)

      },
      syncData() {
        let self = this;

        if (!self.AllInspectionsComplete) {
          self.$refs.YesNoModal.show(
            "Not all inspections have been completed! Are you sure you would like to check out?",
            function (yes) {
              if (yes == true) {
                self.$refs.Loader.setText("Fetching incomplete items...");
                self.StoreIncompletedItemsInIndexedDB();
              } else {
                return;
              }
            }
          );
        } else {
          self.postData();
        }
      },
      postData() {
        let self = this;
        let mw = new supervisorMW(self);

        if (self.canUpload == true) {
          self.$refs.Loader.setText("Posting to server...");
          mw.PostSingleJobTxToServer().then(response => {
              self.$refs.Loader.setText("Complete...");

              console.log("[POSTED TO SERVER]", response);
              self.checkOut();
            })
            .catch(error => {
              self.$refs.ErrorModal.setText("Failed to send data to server : Error : " + error.toString())
              self.$refs.ErrorModal.show();
              self.$refs.Loader.hide();
            })
        } else {
          self.$refs.ProceedModal.show(
            "Checking out requires internet connectivity. Please make sure you are connected to WiFi.",
            function (yes) {
              if (yes == true) {
                self.$refs.Loader.setText("Posting to server...");
                mw.PostSingleJobTxToServer()
                  .then(response => {
                    self.$refs.Loader.setText("Complete...");
                    console.log("[POSTED TO SERVER]", response);
                    self.checkOut();
                  })
                  .catch(error => {
                    self.$refs.ErrorModal.setText("Failed to send data to server : Error : " + error
                      .toString())
                    self.$refs.ErrorModal.show();
                    self.$refs.Loader.hide();
                  })
              }
            }
          );
        }
      },
      CancelJobComplete() {
        let self = this;

        self.$refs.InspectionCompleteForm.reset();
        self.CompleteInspectionDialog = false;
      },
      returnToCustomers() {
        let storeData = {
          CustomerID: null,
          VenueID: null
        };

        this.$store.commit("setLastCheckInData", storeData);
        this.$router.push(`/Supervisor/Customers`);
      },
      GetLocation() {
        let self = this;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            self.showPosition,
            self.locationError
          );
        } else {
          self.location = "Geolocation is not supported by this browser.";
        }
      },
      showPosition(position) {
        let self = this;
        self.location =
          "Latitude: " +
          position.coords.latitude +
          ", Longitude: " +
          position.coords.longitude;
        //self.showInMap(position);
        self.CheckInLong = position.coords.longitude;
        self.CheckInLat = position.coords.latitude;
        console.log("LOCATION", self.location);
      },
      checkOut() {
        let self = this;
        //let sessionData = self.$store.getters.getUserSessionData;
        //let tokenDecoded = JWT.decode(sessionData.AccessToken);
        //  self.syncData();
        self.GetLocation();

        let venueID = self.$route.params.venueID;
        let systemUserID = self.SystemUserID;
        // GET OP CHECK IN FOR THIS VENUE & UPDATE IT
        self.get(`CheckInOut/CheckIn?venueID=${venueID}&systemUserID=${systemUserID}`).then(r => {
          let Request = {
            ID: r.data.ID,
            CustomerVenueID: r.data.CustomerVenueID,
            SystemUserID: r.data.SystemUserID,
            CheckInDateTime: r.data.CheckInDateTime,
            CheckInLat: r.data.CheckInLat,
            CheckInLong: r.data.CheckInLong,
            CheckOutDateTime: moment(Date.now()).format("YYYY-MM-DD hh:mm:ss"),
            CheckOutLat: self.CheckInLat,
            CheckOutLong: self.CheckInLong
          };
          console.log("[CHECKOUT REQUEST]", Request);
          // now update the checked-in item
          self
            .put(`CheckInOut/${Request.ID}`, Request)
            .then(response => {
              self.$refs.Loader.hide();
              let storeData = {
                CustomerID: null,
                VenueID: null
              };

              var LSCheckedInVenues = JSON.parse(localStorage.getItem("CheckedInVenues"));

              var index = LSCheckedInVenues.indexOf(venueID);
              var test = LSCheckedInVenues.filter(filter => {
                return filter != venueID
              })
              // LSCheckedInVenues.splice(index, 1);
              localStorage.setItem('CheckedInVenues', JSON.stringify(test));
              this.$store.commit("setLastCheckInData", storeData);
              self.$router.push(`/Supervisor/Customers`);
            })
            .catch(err => {
              console.error(err.toString())
            });
        });
      }
    }
  };
</script>

<style scoped>
  .camera-modal {
    width: 100%;
    height: 100%;
    top: 20;
    left: 0;
    position: absolute;
    background-color: white;
    z-index: 10;
  }

  .camera-stream {
    width: 100%;
    max-height: 100%;
  }

  .camera-modal-container {
    position: absolute;
    top: 0;
    width: 100%;
    height: 90%;
    margin-bottom: 24px;
  }

  .inputfile+label {
    font-size: 1.25em;
    font-weight: 700;
    color: white;
    background-color: black;
    display: inline-block;
  }
</style>